// extracted by mini-css-extract-plugin
export default {"SanitizedHtml":"use-iteration-editor-module__SanitizedHtml--EEGQu"};